// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZPJ3","icon":"styles_icon__iz2hF"};